import type { PanelRole } from '../../surround-material/functions/get-thickness-for-role';
import type { ExtendedPanelRole, PanelThicknessConfig } from '../types';
import type { SurroundMaterial } from '../../surround-material/surround-material.class';

export type GetThicknessForRoleCfnParams = {
	role: ExtendedPanelRole;
	surround: SurroundMaterial | null;
	panelThickness: PanelThicknessConfig | null;
};

/**
 * Resolves the thickness for a panel role, checking overrides first.
 * Falls back to surround material defaults when no override is set.
 * Supports 'backLeft'/'backRight' for corner islands — falls back to 'back'.
 */
export const getThicknessForRoleCfn = (params: GetThicknessForRoleCfnParams): number => {
	const { role, surround, panelThickness } = params;

	// backLeft/backRight resolve to 'back' for surround material lookup
	const baseRole: PanelRole = (role === 'backLeft' || role === 'backRight') ? 'back' : role;
	const defaultThickness = surround?.getThicknessForRole(baseRole) ?? 0;

	if (!panelThickness) return defaultThickness;

	if (panelThickness.uniform) {
		return panelThickness.thickness ?? defaultThickness;
	}

	// Check specific override first, then fall back to base role, then default
	const { panels } = panelThickness;
	if (!panels) return defaultThickness;

	return panels[role] ?? panels[baseRole] ?? defaultThickness;
};
